const React = require('react');
const Ripple = require('../Ripple');
const Arrow = require('../../icons/ArrowLeftB');


module.exports = (props) => {
  return (
    <Ripple
      centerRipple
      {...props}
      className={`sq50 ov layoutRow fhaC fvaC c5B47FF o70:h dn r st2 `
        + (props.className || '')}
    >
      <Arrow className="w28"/>
    </Ripple>
  );
};
